<template>
    <!-- 新UI -->
    <div class="footer">
        <!-- wrapper -->
        <div class="footer-wrapper">
            <div class="logo-container flex-align">
                <!-- <img src="@/assets/common/logo_f.png" alt="logo" class="logo"> -->
                <h2 class="title">京蒙教育协作智慧平台</h2>
            </div>
            <div class="info flex-align-around">
                <div class="info-item" v-for="(item,name) in info" :key="name" @click="goLink(name)">
                    <span>{{item}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: {
                    team: 'copyright © 首都师范大学版权所有',
                    address: '地址：北京市西三环北路105号 ',
                    postCode: '邮编：100084',
                    email: 'E-mail：info@cnu.edu.cn',
                    icp: '京ICP备17019635号-5',
                    record: '京公网安备：110402430068号'
                }
            }
        },
        methods: {
            goLink(item){
                console.log(item);
                if(item == 'icp'){
                    window.location.href = 'https://beian.miit.gov.cn/#/Integrated/recordQuery'
                }else if(item == 'record'){
                    window.location.href = 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=110402430068'
                }
            }
        },
        mounted() {},
        created() {
            require("../../../config/utils/rem")
        },
    };
</script>

<style lang="less" scoped>
    @font-face {
        font-family: 'rtws';
        src: url("../../../../static/font/RTWSYueGoTrial-Light.otf");
    }

    .footer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: #1c4b90;
        background-image: url("../../../assets/common/footer-bg.png");
        background-position: 50% 50%;
        padding: 3.285rem 0 4.6rem;

        .logo-container {
            width: max-content;
            margin: 0 auto 3.285rem;

            .logo {
                margin-right: 1.97rem;
            }

            .title {
                font-size: 1.97rem;
                color: #fff;
                font-family: rtws;
            }
        }

        // 信息
        .info {
            color: #fff;
            font-size: 1.1823rem;

            .info-item {
                margin-bottom: 0.5rem;
                cursor: default;
            }
        }
    }
</style>